import { Navigate, Outlet, useLocation } from "react-router";
import { useAuthStore } from "./authStore";
/**
* Guard de rutas autenticadas. Tres estados:
*
* 1. loading → spinner (impide flash hacia /login)
* 2. sin sesión → redirige a /login con ?next=<ruta_original>
* 3. autenticado → renderiza el Outlet (subrutas)
*/
export function ProtectedRoute() {
const { loading, session } = useAuthStore();
const location = useLocation();
if (loading) {
return (
<div className="flex h-screen items-center justify-center">
<div className="h-8 w-8 animate-spin rounded-full border-2 border-border border-t-gray-900" />
</div>
);
}
if (!session) {
const next = encodeURIComponent(location.pathname + location.search);
return <Navigate to={`/login?next=${next}`} replace />;
}
return <Outlet />;
}
